import register from "./esm/register/index";

register("panel");
